import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkDeleteApi extends BaseClient {
  public doExternalLinkDelete (id: string) {
    const path: string = '/v1/external-links/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new ExternalLinkDeleteApi()
